const people = {
  1553166414287: {
    name: 'Tamara Abels',
    image: '/images/beautiful-brunette-cute-774909',
    dateofbirth: '1988-11-11',
    title: 'Service designer',
    bio:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sagittis purus sit amet volutpat. Nibh mauris cursus mattis molestie. Platea dictumst vestibulum rhoncus est pellentesque elit ullamcorper dignissim. Massa tincidunt nunc pulvinar sapien et ligula ullamcorper malesuada proin. Lacus luctus accumsan tortor posuere ac ut consequat semper. Vel facilisis volutpat est velit egestas dui. Mauris commodo quis imperdiet massa. Mauris pharetra et ultrices neque ornare aenean euismod. Id aliquet risus feugiat in ante.',
  },
  1553166414288: {
    name: 'Joost Wallenburg',
    image: '/images/adult-beard-boy-220453',
    dateofbirth: '1984-09-21',
    title: 'Front-end engineer',
    bio:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Enim sit amet venenatis urna cursus eget nunc scelerisque viverra. Dignissim sodales ut eu sem integer vitae. Integer eget aliquet nibh praesent. Consectetur purus ut faucibus pulvinar elementum integer. Tellus cras adipiscing enim eu turpis egestas pretium aenean pharetra. Quam adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus urna. Morbi enim nunc faucibus a pellentesque. Pharetra et ultrices neque ornare aenean. Amet luctus venenatis lectus magna fringilla.',
  },
  1553166414289: {
    name: 'Daan Schuurmans',
    image: '/images/attractive-boy-casual-769690',
    dateofbirth: '1985-05-24',
    title: 'Interaction designer',
    bio:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed adipiscing diam donec adipiscing tristique. Eget mauris pharetra et ultrices neque ornare aenean. Aliquam purus sit amet luctus venenatis lectus magna fringilla urna. Nisi scelerisque eu ultrices vitae auctor eu augue. Varius morbi enim nunc faucibus a pellentesque sit amet porttitor. Aliquam sem fringilla ut morbi tincidunt augue interdum velit. Aliquam ut porttitor leo a diam sollicitudin. Arcu non odio euismod lacinia at quis. Amet justo donec enim diam vulputate.',
  },
}

export default people
